module.exports = __webpack_public_path__ + "img/0Q3B7166_Wood_MockedUp.2423433b.jpg";